import { Controller } from '@hotwired/stimulus';

const ELECTRIC_FUEL_TYPE_ID = 6;

export default class ElectricParamsController extends Controller {
  static targets = ['electricParams', 'fuelTypeSelect'];

  connect() {
    this.toggleElectricParams(false);
  }

  onFuelTypeChange(e) {
    if (!e.detail.value.length) {
      this.toggleElectricParams(false);
      return;
    }

    const hasElectric = e.detail.value.some((fuelType) => fuelType.id === ELECTRIC_FUEL_TYPE_ID);
    this.toggleElectricParams(hasElectric);
  }

  toggleElectricParams(visible) {
    this.electricParamsTargets.forEach((target) => target.classList.toggle('d-none', !visible));
  }
}
